export enum FormControlValueTransformer {
	Uppercase,
	RemoveSpecialChars,
	RemoveNumeric
}
